import { Fragment, FunctionComponent } from "react";
import { Checkbox, Table } from "@pjs/core-ui";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { INotificationRowProps } from "./interfaces/INotificationRowProps";
import "./styles/notification-row.css";

export const NotificationRow: FunctionComponent<INotificationRowProps> = (props) => {
    const notification = props.notification;

    return (
        <Fragment>
            <Table.Cell>
                <div className="uui-notification-row__title">{notification.title}</div>
                <div className="uui-notification-row__sub-title">{notification.subTitle}</div>
            </Table.Cell>
            <Table.Cell>
                <div className="uui-notification-row__content-wrapper">
                    <Checkbox
                        ariaLabel={userUiI18n.getString("notifications.individual_checkbox_label", { type: notification.title })}
                        isChecked={props.notification.settings.email}
                        onChange={(isChecked: boolean): void => {
                            notification.settings.email = isChecked;
                            props.updateNotification(notification);
                        }}
                    />
                </div>
            </Table.Cell>
            <Table.Cell>
                <div className="uui-notification-row__content-wrapper">
                    <Checkbox
                        ariaLabel={userUiI18n.getString("notifications.digest_checkbox_label", { type: notification.title })}
                        isChecked={props.notification.settings.digest}
                        onChange={(isChecked: boolean): void => {
                            notification.settings.digest = isChecked;
                            props.updateNotification(notification);
                        }}
                    />
                </div>
            </Table.Cell>
        </Fragment>
    );
};
